import { render, staticRenderFns } from "./PrizesCustomerCategoryModel.vue?vue&type=template&id=6488bcc6&"
import script from "./PrizesCustomerCategoryModel.js?vue&type=script&lang=js&"
export * from "./PrizesCustomerCategoryModel.js?vue&type=script&lang=js&"
import style0 from "./PrizesCustomerCategoryModel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VIcon,VProgressLinear,VTextField})
